module.exports = __webpack_public_path__ + "static/img/word_quiz_title.aea525c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/word_quiz/word_quiz_title.png
// module id = Oqih
// module chunks = 1